var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code",class:_vm.isCountDownShow ? 'counting-down' : 'not-count-dowm'},[(!_vm.isCountDownShow)?_c('div',{staticClass:"code-text"},[_vm._v("获取验证码")]):_c('div',{staticClass:"code-countdown"},[_vm._v(_vm._s(_vm.countDown)+"s后获取")])])
}
var staticRenderFns = []

export { render, staticRenderFns }